import api from "../api/Client";

export type ProfessionalTask = {
  id: number;
  coach_id: number;
  description: string;
  type: string;
  frecuency: string;
  done: number;
  limit_date: string;
  coach_comment: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export async function fetchProfessionalTasks() {
  const response = await api.get("/api/professionals/tasks");
  return (Array.isArray(response.data) ? response.data : []) as ProfessionalTask[];
}

export async function updateProfessionalTaskComment(taskId: number, comment: string, replace = false) {
  await api.patch(`/api/professionals/tasks/${taskId}/comment`, {
    comment,
    replace
  });
}

export async function completeProfessionalTask(taskId: number) {
  await api.patch(`/api/professionals/tasks/${taskId}/complete`);
}
